
import React from 'react';
import Timer from '../components/Timer';
import TaskList from '../components/TaskList';
import { Grid, Box } from '@mui/material';

const HomePage = () => {
  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', p: 2 }}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={6}>
          <Timer />
        </Grid>
        <Grid item xs={12} md={6}>
          <TaskList />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePage;
